import {mapGetters} from "vuex";


export default {
    computed: {
        ...mapGetters(["contentPageModel","platformCategory","platformCategoryName","platformCategories","contentPageNavigationText","service"]),
        showBreadcrumb() {
            return this.contentPageModel.showBreadcrumb
        },
    },
    methods: {
        getPlatformCategory(){
            let platformCategoryObject = {}
            if (this.platformCategories && this.platformCategories.length > 0) {
                this.platformCategories.forEach(category => {
                    if(category.alias == this.platformCategory){
                        platformCategoryObject = category;
                    }
                });
            }
            return platformCategoryObject;
        },
        redirectToDefaultBrowse() {
                let platformCategoryObj = this.getPlatformCategory();

            if(platformCategoryObj && platformCategoryObj.viewAllUrlFormat) {
                window.location.href = EMPLOYEE_HUB_URL+platformCategoryObj.viewAllUrlFormat;
            } else if(this.platformCategory == "PTP") {
                if(this.isOfferingPage()){
                    window.location.href = EMPLOYEE_HUB_URL+"/apps/guides/procurement-guide/"+this.service.serviceLineId;
                }else{
                    this.$router.push("/"+this.platformCategory+"/article-categories");
                }
            } else {
                var resourcePath = this.isOfferingPage() ? "/"+this.platformCategory+"/services/"+this.contentPageModel.serviceSysId : this.$router.push("/"+this.platformCategory+"/article-categories");
                this.$router.push(resourcePath);
            }
        },
        isOfferingPage() {
            return this.contentPageModel.offeringSysId && this.contentPageModel.serviceSysId;
        }
    }
}